export default "__VITE_ASSET__CF0rf4y7__"